module.exports = __webpack_public_path__ + "static/img/corten-steel-identification-signs02.c550bdf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/see-forever/corten-steel-identification-signs02.jpg
// module id = 949
// module chunks = 0